import { useMemo } from 'react';
import { TimeSignal } from 'graphql/types';

export const useTotalDuration = (notes: TimeSignal[]): number => {
  const totalSeconds = useMemo(() => {
    return notes.reduce((accumulator: number, currentSignal: TimeSignal) => {
      const duration = currentSignal.duration || 0;
      return accumulator + duration;
    }, 0);
  }, [notes]);

  return totalSeconds;
};
